export default [
    {
        path: '/trainingUnitIndex', // 培训单位首页
        name: 'trainingUnitIndex',
        component: () => import(/* webpackChunkName: "trainingUnitIndex" */ '@/views/TrainingUnitIndex.vue')
    },
    {
        path: '/trainingUnitProjectList', // 培训单位项目列表
        name: 'trainingUnitProjectList',
        component: () => import(/* webpackChunkName: "trainingUnitProjectList" */ '@/views/TrainingUnit/ProjectList.vue')
    },
    {
        path: '/trainingUnitProjectDetail', // 培训单位项目详情
        name: 'trainingUnitProjectDetail',
        component: () => import(/* webpackChunkName: "trainingUnitProjectDetail" */ '@/views/TrainingUnit/ProjectDetail.vue')
    },
    {
        path: '/trainingUnitProjectTask', // 培训单位项目任务
        name: 'trainingUnitProjectTask',
        component: () => import(/* webpackChunkName: "trainingUnitProjectTask" */ '@/views/TrainingUnit/ProjectTask.vue')
    },
    {
        path: '/trainingUnitMemberSituation', // 培训单位人员情况
        name: 'trainingUnitMemberSituation',
        component: () => import(/* webpackChunkName: "trainingUnitMemberSituation" */ '@/views/TrainingUnit/MemberSituation.vue')
    },
    {
        path: '/trainingUnitMemberDetail', // 培训单位人员情况-详情
        name: 'trainingUnitMemberDetail',
        component: () => import(/* webpackChunkName: "trainingUnitMemberDetail" */ '@/views/TrainingUnit/MemberDetail.vue')
    },
    {
        path: '/trainingUnitNotice', // 培训单位通知
        name: 'trainingUnitNotice',
        component: () => import(/* webpackChunkName: "trainingUnitNotice" */ '@/views/TrainingUnit/Notice.vue')
    },
    {
        path: '/trainingUnitNoticeDetail', // 培训单位通知详情
        name: 'trainingUnitNoticeDetail',
        component: () => import(/* webpackChunkName: "trainingUnitNoticeDetail" */ '@/views/TrainingUnit/NoticeDetail.vue')
    },
    {
        path: '/trainingUnitStatistics', // 业绩统计
        name: 'trainingUnitStatistics',
        component: () => import(/* webpackChunkName: "trainingUnitStatistics" */ '@/views/TrainingUnit/trainingUnitStatistics.vue')
    },
]